const routes = [{
        path: "/indexations",
        name: "indexations",
        component: () =>
            import ("../components/ged/indexations/Indexation.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/indexations/form",
        name: "indexationsform",
        component: () =>
            import ("../components/ged/indexations/Form.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/indexations/form/:id",
        name: "indexationsformEdit",
        component: () =>
            import ("../components/ged/indexations/Form.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/consultations",
        name: "consultations",
        component: () =>
            import ("../components/ged/consultations/consultation.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/document_consulted",
        name: "document_consulted",
        component: () =>
            import ("../components/ged/document_consulted/documentList.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/document_sent",
        name: "document_sent",
        component: () =>
            import ("../components/ged/request_sent/documentList.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/document_recieved",
        name: "document_recieved",
        component: () =>
            import ("../components/ged/document_recieved/documentList.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/document_accepted",
        name: "document_accepted",
        component: () =>
            import ("../components/ged/request_accepted/documentList.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/document_refused",
        name: "document_refused",
        component: () =>
            import ("../components/ged/document_refused/documentList.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/documents/detailByConsId/:id",
        name: "document_detail_by_cons_id",
        component: () =>
            import (
                "../components/ged/detail/DocumentRetailByConsId.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/documents/detailById/:id",
        name: "document_detail_by_id",
        component: () =>
            import (
                "../components/ged/detail/DocumentRetailById.vue"
            ),
        meta: {
            requiresAuth: true
        }
    },

];

export default routes;